import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { formationsData } from '../data/formationsData';
import '../style/components/_autresFormationsCarousel.scss';

const AutresFormationsCarousel = ({ currentId }) => {
    const slides = formationsData
        .filter((formation) => formation.id !== currentId)
        .map((formation) => ({
            title: formation.title,
            titlecarousel: formation.titlecarousel,
            shortDescription: formation.shortDescription,
            publics: formation.publics,
            goals: formation.goals,
            image: formation.img,
            link: formation.link,
        }));

    const [startIndex, setStartIndex] = useState(0);
    const [slidesPerView, setSlidesPerView] = useState(3);

    useEffect(() => {
        const handleResize = () => {
            const emSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const widthInEm = window.innerWidth / emSize;

            if (widthInEm < 48) {
                setSlidesPerView(1);
            } else if (widthInEm < 77) {
                setSlidesPerView(2);
            } else {
                setSlidesPerView(3);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const nextSlide = () => {
        setStartIndex((prevIndex) => {
            const nextIndex = prevIndex + slidesPerView;
            return nextIndex >= slides.length ? 0 : nextIndex;
        });
    };

    const prevSlide = () => {
        setStartIndex((prevIndex) => {
            const nextIndex = prevIndex - slidesPerView;
            return nextIndex < 0 ? Math.max(0, slides.length - slidesPerView) : nextIndex;
        });
    };

    const getVisibleSlides = () => {
        const visibleSlides = [];
        for (let i = 0; i < slidesPerView; i++) {
            const index = (startIndex + i) % slides.length;
            visibleSlides.push({ ...slides[index], originalIndex: index });
        }
        return visibleSlides;
    };

    return (
        <div className="other-carousel">
            <button aria-label="Précédent" className="carousel_button carousel_button-prev" onClick={prevSlide}>
                ᐸ
            </button>
            <div className="carousel_content">
                <div className="carousel_slides-container">
                    {getVisibleSlides().map(({ originalIndex, ...slide }) => (
                        <Link to={slide.link} key={originalIndex} className="carousel_slide">
                            <h4 className="carousel_title">{slide.titlecarousel ? slide.titlecarousel : slide.title}</h4>
                            {slide.image && (
                                <div className="carousel_image-container">
                                    <img src={slide.image} alt={`Slide ${originalIndex + 1}`} className="carousel_image" />
                                </div>
                            )}
                            <div className="carousel_card-content">
                                <p className="carousel_short-description">{slide.shortDescription}</p>
                                <div className="carousel_detailed-description">
                                    <div className="public-target">
                                        <h5>Publics visés</h5>
                                        {Array.isArray(slide.publics) ? (
                                            slide.publics.map((publicItem, index) => (
                                                <ul key={index}><li>{publicItem}</li></ul>
                                            ))
                                        ) : (
                                            <p>{slide.publics}</p>
                                        )}
                                    </div>
                                    <div className="course-goals">
                                        <h5>Objectifs de la formation</h5>
                                        <ul>
                                            {slide.goals.map((goal, index) => (
                                                <li key={index}>{goal}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
            <button aria-label="Suivant" className="carousel_button carousel_button-next" onClick={nextSlide}>
                ᐳ
            </button>
            <div className="carousel_indicators">
                {Array.from({ length: Math.ceil(slides.length / slidesPerView) }, (_, i) => (
                    <span
                        key={i}
                        className={`carousel_indicator ${Math.floor(startIndex / slidesPerView) === i ? 'active' : ''}`}
                        onClick={() => setStartIndex(i * slidesPerView)}
                        onKeyDown={() => setStartIndex(i * slidesPerView)}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default AutresFormationsCarousel;